import { TemplateRenderer } from "./template-renderer.class";

export abstract class TemplateBase {
    protected abstract template: string;

    protected allowedEvents: string[] = ['click', 'input', 'change', 'focus', 'blur'];

    private renderer?: TemplateRenderer;

    private get templateRenderer(): TemplateRenderer {
        if (!this.renderer) {
            this.renderer = new TemplateRenderer(this, this.template, this.allowedEvents);
        }

        return this.renderer;
    }

    private containerElement?: HTMLElement;

    public get shadowRoot(): ShadowRoot | null {
        return this.containerElement?.shadowRoot ?? null;
    }

    public get container(): HTMLElement | undefined {
        return this.containerElement;
    }

    protected abstract getData(): Record<string, unknown>;

    protected render(container: HTMLElement): void {
        this.containerElement = container;

        this.templateRenderer.render(container, this.getData());
    }
}
